<div class="d-block w-100">
  <ul class="list-unstyled" id="searchFields">
    <li>
      <div class="tab w-100">
        <a #batch (click)="getTabContent($event)" [ngClass]="{'active':activeTab == batch.id}" id="batch">
          Batch&nbsp;Number <em class="dropdown-toggle" style="float: right"></em>
        </a>
        <a #numPayments
          (click)="getTabContent($event)"
          [ngClass]="{'active':activeTab == numPayments.id}"
          id="numPayments">
          Number&nbsp;of&nbsp;Payments <em class="dropdown-toggle" style="float: right"></em>
        </a>
        <a #totalAmount
          (click)="getTabContent($event)"
          [ngClass]="{'active':activeTab == totalAmount.id}"
          id="totalAmount">
          Total&nbsp;Amount <em class="dropdown-toggle" style="float: right"></em>
        </a>
        <a #totalTransactionsFeesIncVat
          (click)="getTabContent($event)"
          [ngClass]="{'active':activeTab == totalTransactionsFeesIncVat.id}"
          id="totalTransactionsFeesIncVat">
          Transaction Fees&nbsp;(Incl.&nbsp;VAT)<em class="dropdown-toggle" style="float: right"></em>
        </a>
        <a #settlementFeeIncVat
          (click)="getTabContent($event)"
          [ngClass]="{'active':activeTab == settlementFeeIncVat.id}"
          id="settlementFeeIncVat">
          Settlement Fee&nbsp;&nbsp;(Incl.&nbsp;VAT)<em class="dropdown-toggle" style="float: right"></em>
        </a>
        <a #settlementAmount
          (click)="getTabContent($event)"
          [ngClass]="{'active':activeTab == settlementAmount.id}"
          id="settlementAmount">
          Settlement&nbsp;Amount <em class="dropdown-toggle" style="float: right"></em>
        </a>
        <a #updated (click)="getTabContent($event)" [ngClass]="{'active':activeTab == updated.id}" id="updated">
          Last&nbsp;Updated <em class="dropdown-toggle" style="float: right"></em>
        </a>
        <a #status (click)="getTabContent($event)" [ngClass]="{'active':activeTab == status.id}" id="status">
          Status <em class="dropdown-toggle" style="float: right"></em>
        </a>
      </div>
      <form [formGroup]="form">
        <div>
          @switch (activeTab) {
            @case (batch.id) {
              <div class="tabcontent">
                <input (input)="setSearchCriteria($event)"
                  class="form-control"
                  formControlName="batchNumber"
                  id="batchNumber"
                  onlyNumbers="true"
                  placeholder="Batch Number"
                  type="text"/>
              </div>
            }
            @case (numPayments.id) {
              <div class="tabcontent">
                <input (change)="setSearchCriteria($event)"
                  class="form-control"
                  formControlName="totalTransactionsLower"
                  id="totalTransactionsLower"
                  max="{{totalTransactionsUpper}}"
                  placeholder="Lower Limit"
                  type="number"/> <input (change)="setSearchCriteria($event)"
                  class="form-control"
                  formControlName="totalTransactionsUpper"
                  id="totalTransactionsUpper"
                  min="{{totalTransactionsLower}}"
                  placeholder="Upper Limit"
                  type="number"/>
              </div>
            }
            @case (totalAmount.id) {
              <div class="tabcontent">
                <input (change)="setSearchCriteria($event)"
                  class="form-control"
                  formControlName="totalAmountLower"
                  id="totalAmountLower"
                  max="{{totalAmountUpper}}"
                  min="0"
                  placeholder="Lower Limit"
                  type="number"/> <input (change)="setSearchCriteria($event)"
                  class="form-control"
                  formControlName="totalAmountUpper"
                  id="totalAmountUpper"
                  min="{{totalAmountLower}}"
                  placeholder="Upper Limit"
                  type="number"/>
              </div>
            }
            @case (totalTransactionsFeesIncVat.id) {
              <div class="tabcontent">
                <input (change)="setSearchCriteria($event)"
                  class="form-control"
                  formControlName="totalTransactionFeesInclVatLower"
                  id="totalTransactionFeesInclVatLower"
                  max="{{totalTransactionFeesInclVatUpper}}"
                  min="0"
                  placeholder="Lower Limit"
                  type="number"/> <input (change)="setSearchCriteria($event)"
                  class="form-control"
                  formControlName="totalTransactionFeesInclVatUpper"
                  id="totalTransactionFeesInclVatUpper"
                  min="{{totalTransactionFeesInclVatLower}}"
                  placeholder="Upper Limit"
                  type="number"/>
              </div>
            }
            @case (settlementFeeIncVat.id) {
              <div class="tabcontent">
                <input (change)="setSearchCriteria($event)"
                  class="form-control"
                  formControlName="settlementFeeInclVatLower"
                  id="settlementFeeInclVatLower"
                  max="{{settlementFeeInclVatLower}}"
                  min="0"
                  placeholder="Lower Limit"
                  type="number"/> <input (change)="setSearchCriteria($event)"
                  class="form-control"
                  formControlName="settlementFeeInclVatUpper"
                  id="settlementFeeInclVatUpper"
                  min="{{settlementFeeInclVatUpper}}"
                  placeholder="Upper Limit"
                  type="number"/>
              </div>
            }
            @case (settlementAmount.id) {
              <div class="tabcontent">
                <input (change)="setSearchCriteria($event)"
                  class="form-control"
                  formControlName="totalAmountSettledLower"
                  id="totalAmountSettledLower"
                  max="{{totalAmountSettledUpper}}"
                  min="0"
                  placeholder="Lower Limit"
                  type="number"/> <input (change)="setSearchCriteria($event)"
                  class="form-control"
                  formControlName="totalAmountSettledUpper"
                  id="totalAmountSettledUpper"
                  min="{{totalAmountSettledLower}}"
                  placeholder="Upper Limit"
                  type="number"/>
              </div>
            }
            @case (updated.id) {
              <div class="tabcontent">
                <div class="date-input-group">
                  <label class="date-label" for="updatedLower">From:</label>
                  <input (change)="setSearchCriteria($event)"
                    class="form-control d-inline"
                    formControlName="updatedLower"
                    id="updatedLower"
                    max="{{updatedUpper}}"
                    placeholder=""
                    type="date"
                    value="{{updatedLower}}"/>
                </div>
                <div class="date-input-group">
                  <label class="date-label" for="updatedUpper">To:</label>
                  <input (change)="setSearchCriteria($event)"
                    class="form-control d-inline"
                    formControlName="updatedUpper"
                    id="updatedUpper"
                    min="{{updatedLower}}"
                    name="dpToDate"
                    placeholder=""
                    type="date"
                    value="{{updatedUpper}}"/>
                </div>
              </div>
            }
            @case (status.id) {
              <div class="tabcontent">
                <select (change)="setSearchCriteria($event)"
                  class="form-control"
                  formControlName="displayStatus"
                  id="displayStatus">
                  @for (opt of statusOptions; track opt) {
                    <option
                      [selected]="displayStatus == opt"
                      [value]="opt">{{ opt }}
                    </option>
                  }
                </select>
              </div>
            }
          }
        </div>
        <div class="row">
          <div [hidden]="!tabActive" class="col-md-12 text-center">
            <button (click)="clear(activeTab)"
              [disabled]="disableClear(activeTab)"
              class="navy-btn btn-margin-left-right-5 btn-margin-top-bottom-10"
              type="button">
              Clear
            </button>
            <button (click)="clearAll()"
              [disabled]="disableClearAll()"
              class="navy-btn btn-margin-left-right-5 btn-margin-top-bottom-10"
              type="button">
              Clear All
            </button>
            <button (click)="search()"
              class="navy-btn btn-margin-left-right-5 btn-margin-top-bottom-10"
              type="submit">
              Update
            </button>
          </div>
        </div>
      </form>
    </li>
  </ul>
</div>